import { removeBlankPropertiesFromObject } from "../../src/utils";

/**
 * Map elavon request from IW internal data schema to elavon
 *
 * @param {cardNumber: String, cardHolder: String, expDate: String, cardEncoded: String, zipCode: String, invoiceNumber: String, token: String, tokenCard: String}
 * @returns {mappedElavonRequest}
 */
export const mapElavonRequest = (params) => {
  const { cardNumber, cardHolder, cardEncoded, expDate, zipCode, invoiceNumber, token, tokenCard } = params;
  const firstName = cardHolder?.split(" ")[0];
  const lastName = cardHolder?.split(" ")[1];

  const mappedElavonRequest = {
    ssl_txn_auth_token: token,
    ssl_card_number: cardNumber,
    ssl_token: tokenCard,
    // Not sending ssl_exp_date because if we send this, we also have to send ssl_avs_zip which is currently not stored in the cc_tokens service
    // See ticket for context: https://spotonteam.atlassian.net/browse/IWA-6042
    ssl_exp_date: expDate && zipCode ? expDate : "",
    ssl_first_name: firstName,
    ssl_last_name: lastName,
    ssl_cvv2cvc2: cardEncoded,
    ssl_invoice_number: invoiceNumber,
    // Only populate zipCode if expDate is also present
    ssl_avs_zip: expDate && zipCode ? zipCode : ""
  };

  return removeBlankPropertiesFromObject(mappedElavonRequest);
};

/**
 * Map elavon apple pay request from IW internal data schema to elavon
 *
 * @param {invoiceNumber: String, token: String}
 * @returns {mappedAPElavonRequest}
 */

export const mapElavonAPRequest = (invoiceNumber, token) => {
  const mappedAPElavonRequest = {
    ssl_txn_auth_token: token || "",
    ssl_invoice_number: invoiceNumber || ""
  };

  return mappedAPElavonRequest;
};
